module.exports = __webpack_public_path__ + "img/01-illu-kafu2021.f535b808.png";